exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../node_modules/css-loader/index.js!./style/var.scss"), "");
exports.i(require("-!../node_modules/css-loader/index.js!./style/main.scss"), "");

// module
exports.push([module.id, ".vhome{padding-top:4.4em!important}.vhome1{padding-top:8.4em!important}.graybg{width:100%;height:100vh;background:gray;opacity:.4;position:fixed;top:0;left:0;z-index:10}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c0a9bd0e","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 485
// module chunks = 0